export default "__VITE_ASSET__Blxli60d__"